import { defineMessages } from '@jutro/locale';

export default defineMessages({
    bundle: {
        id: 'ml.gateway.policySummary.bundle',
        defaultMessage: 'Bundle'
    },
    noPolicies: {
        id: 'ml.gateway.policySummary.noPolicies',
        defaultMessage: 'There are no policies on this account'
    }
});